import ArrowBackIcon from '@mui/icons-material/ArrowBack'
import FileDownloadIcon from '@mui/icons-material/FileDownload'
import {
  Button,
  CircularProgress,
  Divider,
  Grid,
  Typography
} from '@mui/material'
import { useMemo } from 'react'
import { Helmet } from 'react-helmet-async'
import { useNavigate, useParams } from 'react-router-dom'
import { ExcelService } from '../../../../../Utils/ExportToExcelTicketDetails'
import { useSelector } from 'react-redux'
import useDisconnectedSensors from '../utils/useDisconnectedSensors'
import DisconnectedSensorsTable from './DisconnectedSensorsTable'
import ErrorBoundary from './Error'

const DisconnectedSensors = () => {
	const plantsList = useSelector((state: any) => state.plantsList)
	const { plantId } = useParams()
	const currentPlant = useMemo<any>(
		() => plantsList?.plants?.find((plant: any) => plant._id === plantId),
		[plantsList?.plants, plantId]
	)

	const navigate = useNavigate()

	const { disconnectedSensorsList, setDisconnectedSensorsList, isLoading } =
		useDisconnectedSensors({ plantId })

	// function to convert data in excel format
	const exportCSV = async () => {
		const excelService = new ExcelService()
		const date = new Date()

		let formattedDate = `${date
			.toLocaleString('en-US', {
				year: '2-digit',
				month: '2-digit',
				day: '2-digit',
				hour: '2-digit',
				minute: '2-digit',
				second: '2-digit',
				hour12: false,
				timeZoneName: 'short'
			})
			.replace(/\//g, '')
			.replace(/,/g, '_')
			.replace(/ /g, '')
			.replace(/:/g, '')}`

		// Check if formattedDate contains either '+' or '-'
		const plusIndex = formattedDate.indexOf('+')
		const minusIndex = formattedDate.indexOf('-')

		// Find the index of the first occurrence of either '+' or '-'
		const cutIndex =
			plusIndex !== -1
				? plusIndex
				: minusIndex !== -1
				? minusIndex
				: formattedDate.length

		// Slice the formattedDate up to the found index
		formattedDate = formattedDate.slice(0, cutIndex)

		const data: any = [[...disconnectedSensorsList]]
		await excelService.exportAsExcelFile(
			data,
			`NB ARCH- DisconnectedSensors- ${currentPlant.plant_code}- ${formattedDate}`,
			[`Disconnected Sensors- ${currentPlant.plant_code}`]
		)
	}

	return (
		<ErrorBoundary>
			<Helmet>
				<title style={{ color: 'yellow' }}>Disconnected Sensors</title>
			</Helmet>
			<Grid
				container
				justifyContent='space-between'
				alignItems='center'
				spacing={2}
				style={{
					padding: '5px 30px'
				}}
				sx={theme => ({
					fill: theme.palette.common.white,
					stroke: theme.palette.divider,
					strokeWidth: 1
				})}
			>
				<Grid item xs={12}></Grid>
				<Grid
					item
					onClick={() =>
						navigate(`/usecase/motors-and-pumps`, {
							state: {
								currentViewPlant: currentPlant
							}
						})
					}
				>
					<ArrowBackIcon />
				</Grid>

				<Grid item xs={7}>
					<Typography
						style={{
							textAlign: 'center',
							fontWeight: '500',
							fontSize: '16px'
						}}
						align='left'
					>
						{currentPlant?.plant_name}
					</Typography>
					<Typography
						style={{
							textAlign: 'center',
							fontWeight: '700',
							fontSize: '24px'
						}}
						align='right'
					>
						Disconnected Sensors
					</Typography>
				</Grid>

				<Button
					variant='contained'
					endIcon={<FileDownloadIcon />}
					onClick={exportCSV}
					disabled={disconnectedSensorsList.length === 0}
				>
					Export
				</Button>
			</Grid>
			<Divider
				style={{
					margin: '5px 28px',
					width: '-webkit-fill-available',
					height: '2px',
					backgroundColor: '#8476EF',
					opacity: 0.4
				}}
			/>
			{ (disconnectedSensorsList && isLoading) ? ( 
				<>
					<div
						style={{
							display: 'flex',
							flexDirection: 'column',
							alignItems: 'center',
							justifyContent: 'center',
							height: '70vh',
							width: '93%'
						}}
					>
						<CircularProgress style={{ color: 'white' }} />
						<p
							style={{ color: 'white', marginTop: '20px', fontSize: '1.2rem' }}
						>
							Fetching tags from cube
						</p>
					</div>
				</>
			) :(
				<DisconnectedSensorsTable
					setDisConnectedSensorsList={setDisconnectedSensorsList}
					disConnectedSensorsList={disconnectedSensorsList}
				/>
				)}
		</ErrorBoundary>
	)
}

export default DisconnectedSensors
